import React from 'react';
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next';

const LabelPolicy = ({ classes, className, onChange }) => {
  const { t } = useTranslation();
  const _t = s => t(`default.labelPolicy.${s}`)

  const contractURL = 'https://4kst.com/wp-content/uploads/2022/02/contrat_4kst_consulta_latest.pdf'

  return (
    <label>
      <input type="checkbox" onChange={onChange} />
      <span className={[classes.p, className || ''].join(' ')}>
        {_t('start')}
        <a href={contractURL} rel="noreferrer" target="_blank" className={classes.a}>{_t('contract')}</a>
      </span>
    </label>
    
  );
};

const styles = theme => ({
  p: {
    color: theme.palette.secondary.main
  },
  a: {
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  }
})

export default withStyles(styles)(LabelPolicy);
